export default "__VITE_ASSET__0225542b__"